const _ = require("lodash");
const Common = require("./CommonHelpers");
const DrawingUtil = require("../../util/DrawingUtil");
const ColorUtil = require("../../util/ColorUtil");
const colors = ColorUtil.getDiagramColors();

// Draws a dot symbol centered at (x,y) in a cell of size cellSize with given color.
const drawDot = function(ctx, x, y, cellSize, color) {
	ctx.strokeStyle = color;
	DrawingUtil.drawRegularShape(
		ctx,
		x + cellSize / 2,
		y + cellSize / 2,
		0,
		cellSize / 2,
		0,
		color
	);
};

// Draws a blank space centered at (x,y) in a cell of size cellSize with given color.
const drawBlank = function(ctx, x, y, cellSize, color) {};

// Draws a '404' symbol centered at (x,y) in a cell of size cellSize with given color.
const drawSymbolNotFound = function(ctx, x, y, cellSize, color = null) {
	const padding = 0.05 * cellSize;
	const x0 = x + padding;
	const y0 = y + padding;
	const s0 = cellSize - 2 * padding;
	const w = ctx.measureText("404").width;
	ctx.save();
	ctx.translate(x0, y0);
	ctx.fillStyle = "rgb(255,192,192)";
	ctx.fillRect(0, 0, s0, s0);
	ctx.strokeStyle = "red";
	ctx.strokeRect(0, 0, s0, s0);
	ctx.fillStyle = "red";
	ctx.scale(s0 / w, s0 / w);
	ctx.textBaseline = "middle";
	ctx.textAlign = "center";
	ctx.fillText("404", w / 2, w / 2);
	ctx.restore();
};

// Draws a grid of symbols.
const drawDotGroups = function(ctx, x, y, grid, settings = {}) {
	const symbolMap = _.extend(
		{".": drawDot, " ": drawBlank},
		settings.symbolMap
	);
	// Check for scheme colors
	const schemeColors = {};
	if (settings.symbolColors) {
		_.map(settings.symbolColors, (color, symbolType) => {
			const parsedColor = colors[color];
			if (parsedColor) schemeColors[symbolType] = parsedColor;
		});
	}
	const symbolColors = _.extend({".": colors.royalblue}, schemeColors);
	const {
		cellSize = parseInt(ctx.font) * 1.15,
		padding = 0.2 * cellSize,
		border = false,
		scale = 1,
		fitCanvasToSize = false, // canvas is resized to the width/height of the dot group
		// if fitCanvasToSize is true, this effectively does nothing
		centerOnCanvas = false, // ignore the x and y values passed in and center the dot groups on the canvas
		// generally speaking, we should never use both triGrid and triGridAlt
		triGrid = false, // odd-indexed rows are shifted right half a cell
		triGridAlt = false, // even-indexed rows are shifted right half a cell
	} = settings;
	const symbolNotFound = drawSymbolNotFound;
	const isShifted = index => {
		if (!triGrid && !triGridAlt) return false;
		return index % 2 === (triGridAlt ? 0 : 1);
	};
	const gridWidth = grid.reduce((max, row) => Math.max(max, row.length), 0); // number of columns
	const gridHeight = grid.length; // number of rows
	const boxSize = cellSize + padding;
	const halfBoxSize = boxSize / 2;
	// if (one of) the longest rows is shifted, we need to add another half cell of width
	const longestRowIsShifted = grid.reduce(
		(shifted, row, index) =>
			shifted || (isShifted(index) && row.length === gridWidth),
		false
	);
	const gridPixelWidth =
		scale * (gridWidth * boxSize + (longestRowIsShifted ? halfBoxSize : 0));
	const gridPixelHeight = scale * (gridHeight * boxSize);

	ctx.save();
	if (fitCanvasToSize) {
		ctx.setSize(gridPixelWidth, gridPixelHeight);
	}

	const {width: canvasWidth, height: canvasHeight} = ctx.getSize();
	if (
		centerOnCanvas &&
		gridPixelWidth <= canvasWidth &&
		gridPixelHeight <= canvasHeight
	) {
		x = x + (canvasWidth - gridPixelWidth) / 2;
		y = y + (canvasHeight - gridPixelHeight) / 2;
	}

	// draw the contents of the grid
	ctx.scale(scale, scale);
	ctx.translate(x + (triGrid ? halfBoxSize : 0), y);
	grid.forEach((row, rowIndex) => {
		// triangulation of grid
		if (triGrid || triGridAlt) {
			const direction = isShifted(rowIndex) ? 1 : -1;
			ctx.translate(direction * halfBoxSize, 0);
		}

		row.split("").forEach((cell, cellIndex) => {
			const cellX = cellIndex * boxSize + padding / 2;
			const cellY = rowIndex * boxSize + padding / 2;
			const symbol = symbolMap[cell] || symbolNotFound;
			// if the symbol maps to a function, then call it. Otherwise, draw it as a batex string
			if (_.isFunction(symbol)) {
				symbol(ctx, cellX, cellY, cellSize, symbolColors[cell] || null);
			} else {
				Common.drawBatexAtCenter(
					ctx,
					symbol,
					cellX + 0.5 * cellSize,
					cellY + 0.5 * cellSize
				);
			}
		});
	});

	// draw border of the grid
	if (border) {
		ctx.strokeRect(0, 0, gridPixelWidth, gridPixelHeight);
	}
	ctx.restore();
};

module.exports = drawDotGroups;
